module.exports = __webpack_public_path__ + "static/media/img-1.292d30e3.jpg";